export enum ComponentPlacementType {
  Leaf = 'LEAF',
  Container = 'CONTAINER'
}
